import {Component, Inject, Input, OnInit} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {MainDataModels} from 'src/app/models/maindata-models';
import {ObjektModels} from 'src/app/models/objekt-models';
import {MainDataService} from 'src/app/services/main-data.service';
import {MessageBoxService} from 'src/app/services/message-box.service';
import {ObjektDataService} from 'src/app/services/objekt-data.service';
import {SwissSettingsService} from 'src/app/services/swiss-settings.service';
import {v4 as uuidv4} from 'uuid';
import {ObjektAdresseComponent} from '../../objekte/objekt-adresse/objekt-adresse.component';
import moment, {Moment} from 'moment';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';
import ObjektAdresseDialogInput = ObjektModels.ObjektAdresseDialogInput;

@Component({
    selector: 'app-termin-eintrag',
    templateUrl: './termin-eintrag.component.html',
    styleUrls: ['./termin-eintrag.component.scss'],
})
export class TerminEintragComponent implements OnInit {
    @Input() formGroupTermin: UntypedFormGroup;
    public cardTitle = 'MAIN_APP_DIALOG.INPUT_DIALOG.NEW_APPOINTMENT.title';
    objekte: Array<MainDataModels.SearchFieldResponseObjekt> = []; // Leeres Objekte-Array erstellen (SearchFieldResponseObjekt[])
    filteredDescriptions?: Observable<MainDataModels.SearchFieldResponseObjekt[]>;
    public errormsg = '';
    public hasError = false;
    public nurMeinenTerminAktualisieren = true;
    public innerWidth: any;
    /* Mitarbeiterauswahl (event. mit Gruppen) */
    public dbMitarbeiter?: MainDataModels.Mitarbeiter[];
    public dbGruppen?: MainDataModels.MitarbeiterGruppe[];
    public dbGruppenZuord?: MainDataModels.MitarbeiterGruppeZuord[];
    public dbKategorien: MainDataModels.Kategorie[] = [];
    public dbStatus: MainDataModels.TerminStatus[] = [
        {name: 'Frei', status: 0},
        {name: 'Mit Vorbehalt', status: 1},
        {name: 'Gebucht', status: 2},
        {name: 'Abwesend', status: 3},
        {name: 'An anderem Ort tätig', status: 4},
    ];
    public dbReminder: MainDataModels.TerminErinnerung[] = [
        {id: 1, name: '(Keine)', reminder: 0, minuten: -1},
        {id: 2, name: '0 Minuten', reminder: 1, minuten: 0},
        {id: 3, name: '5 Minuten', reminder: 1, minuten: 5},
        {id: 4, name: '10 Minuten', reminder: 1, minuten: 10},
        {id: 5, name: '15 Minuten', reminder: 1, minuten: 15},
        {id: 6, name: '30 Minuten', reminder: 1, minuten: 30},
        {id: 7, name: '1 Stunde', reminder: 1, minuten: 60},
        {id: 8, name: '2 Stunden', reminder: 1, minuten: 120},
        {id: 9, name: '3 Stunden', reminder: 1, minuten: 180},
        {id: 10, name: '4 Stunden', reminder: 1, minuten: 240},
        {id: 11, name: '5 Stunden', reminder: 1, minuten: 300},
        {id: 12, name: '6 Stunden', reminder: 1, minuten: 360},
        {id: 13, name: '7 Stunden', reminder: 1, minuten: 420},
        {id: 14, name: '8 Stunden', reminder: 1, minuten: 480},
        {id: 15, name: '9 Stunden', reminder: 1, minuten: 540},
        {id: 16, name: '10 Stunden', reminder: 1, minuten: 600},
        {id: 17, name: '11 Stunden', reminder: 1, minuten: 660},
        {id: 18, name: '0.5 Tage', reminder: 1, minuten: 720},
        {id: 19, name: '1 Tag', reminder: 1, minuten: 1440},
        {id: 20, name: '2 Tage', reminder: 1, minuten: 2880},
        {id: 21, name: '3 Tage', reminder: 1, minuten: 4320},
        {id: 22, name: '4 Tage', reminder: 1, minuten: 5760},
        {id: 23, name: '5 Tage', reminder: 1, minuten: 7200},
        {id: 24, name: '6 Tage', reminder: 1, minuten: 8640},
        {id: 25, name: '1 Woche', reminder: 1, minuten: 10080},
        {id: 26, name: '2 Wochen', reminder: 1, minuten: 20160},
    ];
    public showUserGroups = false;
    /* Objekt-Adressen */
    public objectAddresses: MainDataModels.ObjektAdresseSlim[] = [];
    private currTerminMitBenutzer: MainDataModels.TerminMitBenutzer = MainDataModels.EmptyTerminMitBenutzer();

    constructor(
        private svcMainData: MainDataService,
        private swissSettings: SwissSettingsService,
        private svcObjektData: ObjektDataService,
        private svcMessageBox: MessageBoxService,
        public dialog: MatDialog,
        public dialogRef: MatDialogRef<TerminEintragComponent>,
        @Inject(MAT_DIALOG_DATA) public data: MainDataModels.TerminMitBenutzer
    ) {
        if (data) {
            this.currTerminMitBenutzer = this.data;
            if (!this.currTerminMitBenutzer.istNeuerTermin) {
                this.cardTitle = 'MAIN_APP_PENDENZEN.editAppointment';
            }
        }

        this.formGroupTermin = new UntypedFormGroup({
            fldStatus: new UntypedFormControl(),
            fldErinnerung: new UntypedFormControl(),
            fldPrivat: new UntypedFormControl(),
            fldKategorie: new UntypedFormControl(),
            fldObjekt: new UntypedFormControl(),
            fldAdresse: new UntypedFormControl(),
            fldTitel: new UntypedFormControl(),
            fldOrt: new UntypedFormControl(),
            fldStartDatum: new UntypedFormControl(),
            fldStartZeit: new UntypedFormControl(),
            fldEndDatum: new UntypedFormControl(),
            fldEndZeit: new UntypedFormControl(),
            fldMitarbeiter: new UntypedFormControl(),
            fldNotizen: new UntypedFormControl(),
            fldNurMeinenTermin: new UntypedFormControl(),
        });
    }

    ngOnInit(): void {
        this.innerWidth = window.innerWidth;
        if (!(this.data as any).position?.top) {
            this.dialogRef.updatePosition({top: '3.75rem'});
        }
        // Objekte für Objektsuche laden
        this.refreshSuchfeldBeschreibungen().then((res) => {
            if (this.data.termin.objectID) {
                const obj = this.objekte.find(o => o.objectID == this.data.termin.objectID);
                if (obj) {
                    this.selectedSearchItem({option: {value: {objectID: this.data.termin.objectID}}});
                    this.formGroupTermin.controls['fldObjekt'].setValue(obj);
                }
            }
            // Mitarbeiter laden
            this.svcMainData.getMitarbeiterWithDB().then((res) => {
                this.dbMitarbeiter = res.filter((mi) => mi.active === 1).sort((a, b) => (a.loginname.toLocaleLowerCase() > b.loginname.toLocaleLowerCase() && 1) || -1);
                this.loadFieldValues();
            });

            // Mitarbeiter-Gruppen laden
            this.svcMainData.getMitarbeiterGruppenWithDB().then((res) => {
                this.dbGruppen = res.sort((a, b) => (a.description.toLocaleLowerCase() > b.description.toLocaleLowerCase() && 1) || -1);
                // Hier werden die ID's für die Gruppen negativ gemacht, weil die gleiche ID auch bei den Mitarbeitern vorhanden sein könnte
                this.dbGruppen.forEach((g) => (g.id = g.id * -1));
            });

            // Mitarbeiter Gruppenzuordnungen laden
            this.svcMainData.getMitarbeiterGruppenZuordWithDB().then((res) => {
                this.dbGruppenZuord = res;
            });

            // Termin-Kategorien laden
            this.svcMainData.getKategorienWithDB().then((res) => {
                this.dbKategorien = res;
            });

            this.filteredDescriptions = this.formGroupTermin.controls['fldObjekt'].valueChanges.pipe(startWith(''), map((value) => this._filter(value)));

            this.svcMainData.getMitarbeiterGruppenExists().then((res) => {
                this.showUserGroups = res;
            });
        });
    }

    // Hier werden die Namen für die Mitarbeiterauswahl angezeigt
    public getMitarbeiter(mi: MainDataModels.Mitarbeiter): string {
        let mitarbeiter = mi.loginname;
        if (mi.firstname && mi.lastname) {
            mitarbeiter += ' (' + mi.lastname + ' ' + mi.firstname + ')';
        } else if (mi.lastname) {
            mitarbeiter += ' (' + mi.lastname + ')';
        } else if (mi.firstname) {
            mitarbeiter += ' (' + mi.firstname + ')';
        }
        return mitarbeiter;
    }

    getObjektDesc(item: MainDataModels.SearchFieldResponseObjekt): string {
        return item?.beschreibung || '';
    }

    // Suchelement wurde angeklickt
    selectedSearchItem(event: any): void {
        if (this.swissSettings.getWebConfig().debugMode) {
            console.log(event.option.value);
        }
        if (event) {
            this.currTerminMitBenutzer.termin.objectID = event.option.value.objectID;
            this.loadObjectAdressen();
        }
    }

    selectedAddress(event: any): void {
        if (this.swissSettings.getWebConfig().debugMode) {
            console.log(event);
        }
        if (event) {
            this.currTerminMitBenutzer.termin.adressID = event.value.adressID;
        }
    }

    public isStoreInOutlookChecked(): boolean {
        const storeInOL: unknown = this.currTerminMitBenutzer?.termin?.storeInOL;
        return storeInOL === true || storeInOL === 1 || storeInOL === '1';
    }

    public storeInOutlookChanged(checked: boolean): void {
        this.currTerminMitBenutzer.termin.storeInOL = checked ? 1 : 0;
    }

    private normalizeStoreInOutlookFlag(): void {
        this.currTerminMitBenutzer.termin.storeInOL = this.isStoreInOutlookChecked() ? 1 : 0;
    }

    refreshSuchfeldBeschreibungen(): Promise<boolean> {
        return new Promise((resolve) => {
            this.objekte = [];
            this.svcObjektData
                .getSuchfeldBeschreibungen()
                .subscribe({
                    next: (res) => {
                        this.objekte = this.objekte.concat(res);
                        if (this.swissSettings.getWebConfig().debugMode) {
                            console.log('Geladene Objekte', this.objekte);
                        }
                        resolve(true);
                    },
                });
        });
    }

    save() {
        // Neuer Zeiteintrag wird in IndexedDB gespeichert
        if (this.swissSettings.getWebConfig().debugMode) {
            console.log('FormValues: ', this.formGroupTermin.value);
        }

        try {
            if (this.formGroupTermin.value) {
                // Status
                this.currTerminMitBenutzer.termin.busyStatus = this.formGroupTermin.controls['fldStatus'].value;

                // Erinnerung
                if (this.formGroupTermin.controls['fldErinnerung'].value === -1) {
                    // Keine Erinnerung
                    this.currTerminMitBenutzer.termin.reminder = 0;
                    this.currTerminMitBenutzer.termin.reminderNumber = 0;
                } else {
                    this.currTerminMitBenutzer.termin.reminder = 1;
                    this.currTerminMitBenutzer.termin.reminderNumber = this.formGroupTermin.controls['fldErinnerung'].value;
                }

                // Kategorie(n)
                let kategorien = this.formGroupTermin.controls['fldKategorie'].value;
                this.currTerminMitBenutzer.terminKategorien = [];
                if (kategorien && kategorien.length > 0) {
                    kategorien.forEach((element: number) => {
                        const category = this.dbKategorien.find((tk) => tk.id == element);
                        const tkz: MainDataModels.TerminKategorieZuord = {
                            id: uuidv4(),
                            calenderID: this.currTerminMitBenutzer.termin.id,
                            categoryID: category?.id,
                        };

                        this.currTerminMitBenutzer.terminKategorien.push(tkz);
                    });
                }

                if (this.formGroupTermin.controls['fldPrivat'].value === true || this.formGroupTermin.controls['fldPrivat'].value === 1) {
                    this.currTerminMitBenutzer.termin.private = 1;
                } else {
                    this.currTerminMitBenutzer.termin.private = 0;
                }

                // Adresse
                const addresse = this.formGroupTermin.controls['fldAdresse'].value;
                if (addresse) {
                    this.currTerminMitBenutzer.termin.adressID = addresse.adressID;
                }

                // Mitarbeiter & Mitarbeitergruppen
                const employees = this.formGroupTermin.controls['fldMitarbeiter'].value;

                // Wenn negative Einträge bei den Mitarbeitern vorhanden sind, dann handelt es sich um Gruppen
                // Diese müssen hier zu Mitarbeitern gemacht werden.
                const mitarbeiterOhneGruppen: MainDataModels.Mitarbeiter[] = [];
                employees.forEach((element: number) => {
                    // Positive Werte sind ausgewählte Mitarbeiter (UserID / Tabelle Users)
                    // Negative Werte sind ausgewählte Gruppen (Tabelle UserGroups / GroupMembers )
                    if (element >= 0) {
                        const employee = this.dbMitarbeiter?.find((mi) => mi.userID == element);
                        if (employee) {
                            // Prüfen, ob der Mitarbeiter nicht schon vorhanden ist.
                            if (mitarbeiterOhneGruppen.filter((m) => m.userID === employee.userID).length === 0) {
                                mitarbeiterOhneGruppen.push(employee);
                            }
                        }
                    } else {
                        let groupID = element * -1;
                        this.dbGruppenZuord
                            ?.filter((g) => g.id == groupID)
                            .forEach((zuord: MainDataModels.MitarbeiterGruppeZuord) => {
                                let mitarbeiter = this.dbMitarbeiter?.filter((mi) => mi.userID == zuord.userID)[0];
                                if (mitarbeiter) {
                                    // Prüfen, ob der Mitarbeiter nicht schon vorhanden ist.
                                    if (mitarbeiterOhneGruppen.filter((m) => m.userID === mitarbeiter.userID).length === 0) {
                                        mitarbeiterOhneGruppen.push(mitarbeiter);
                                    }
                                }
                            });
                    }
                });
                this.currTerminMitBenutzer.mitarbeiter = mitarbeiterOhneGruppen;

                // Titel
                this.currTerminMitBenutzer.termin.description = this.formGroupTermin.controls['fldTitel'].value;

                // Ort
                this.currTerminMitBenutzer.termin.location = this.formGroupTermin.controls['fldOrt'].value;

                // Start-Datum
                let startDatum = this.formGroupTermin.controls['fldStartDatum'].value;
                if (typeof startDatum === 'string') {
                    startDatum = new Date(startDatum as string);
                }
                if (!(startDatum instanceof Date)) {
                    startDatum = (startDatum as Moment).toDate();
                }
                this.currTerminMitBenutzer.termin.startDate = startDatum;


                // Start-Zeit
                this.currTerminMitBenutzer.termin.startTime = this.formGroupTermin.controls['fldStartZeit'].value;

                // End-Datum
                let endDate = this.formGroupTermin.controls['fldEndDatum'].value;
                if (typeof endDate === 'string') {
                    endDate = new Date(endDate as string);
                }
                if (!(endDate instanceof Date)) {
                    endDate = (endDate as Moment).toDate();
                }
                this.currTerminMitBenutzer.termin.endDate = endDate;

                // End-Zeit
                this.currTerminMitBenutzer.termin.endTime = this.formGroupTermin.controls['fldEndZeit'].value;

                // Notizen
                const noteText = this.formGroupTermin.controls['fldNotizen'].value;
                this.currTerminMitBenutzer.termin.notes = typeof noteText === 'string'
                    ? noteText.replace(/\r\n|\r|\n/g, '\r\n')
                    : noteText;

                if (this.formGroupTermin.controls['fldNurMeinenTermin'].value === true || this.formGroupTermin.controls['fldNurMeinenTermin'].value === 1) {
                    this.currTerminMitBenutzer.nurDiesenTerminBearbeiten = true;
                } else {
                    this.currTerminMitBenutzer.nurDiesenTerminBearbeiten = false;
                    if (!this.currTerminMitBenutzer.termin.groupID && mitarbeiterOhneGruppen.length > 1) {
                        this.currTerminMitBenutzer.termin.groupID = uuidv4();
                    }
                }

                if (this.swissSettings.getWebConfig().debugMode) {
                    console.log('terminMitBenutzer', this.currTerminMitBenutzer);
                }
            }

            this.normalizeStoreInOutlookFlag();

            if (this.currTerminMitBenutzer && this.isEntireDayEvent(this.currTerminMitBenutzer.termin)) {
                this.currTerminMitBenutzer.termin.IsAllDay = true;
            }

            if (this.hasError) {
                // Zuvor vorhandener Fehler zurücksetzen
                this.hasError = false;
                this.errormsg = '';
            }

            this.dialogRef.close(this.currTerminMitBenutzer);
        } catch (ex) {
            // Fehlermeldung muss ausgegeben werden!!! Zeiten müssen gespeichert werden können.
            this.hasError = true;
            this.errormsg = 'Fehler bei der Speicherung der Zeit: ';
            console.error(this.errormsg, ex);
            this.svcMessageBox.showError('⚠️ ❗❗ Der Termin konnte nicht gespeichert werden!! ❗❗ ⚠️', '!! FEHLER !!');
        }
    }

    isEntireDayEvent(termin: any) {
        return termin.startTime == '00:00' && termin.endTime == '00:00' && termin.startDate == termin.endDate;
    }

    addObjectAddress() {
        if (this.currTerminMitBenutzer.termin.objectID) {
            const dialogData: ObjektAdresseDialogInput = {
                objektAdresseZuord: {
                    id: '00000000-0000-0000-0000-000000000000',
                    objectID: this.currTerminMitBenutzer.termin!.objectID,
                    addressType: 5, // Diverses
                    addressContact: 0,
                    adressNumber: 0,
                    adressID: '',
                }, blDoCheckUnique: true, blDisableAdrTypeSelect: false,
            };
            var dialogRef = this.dialog.open(ObjektAdresseComponent, {
                disableClose: true, width: '95%', data: dialogData,
            });

            dialogRef.afterClosed().subscribe({
                next: (result) => {
                    if (result) {
                        dialogData.objektAdresseZuord = result;
                        if (dialogData.objektAdresseZuord) {
                            this.svcObjektData.addObjectAddress(dialogData!.objektAdresseZuord).subscribe({
                                next: (res) => {
                                    this.loadObjectAdressen(dialogData.objektAdresseZuord.adressID);
                                    this.currTerminMitBenutzer.termin.adressID = dialogData.objektAdresseZuord.adressID;

                                    if (dialogData.objektAdresseZuord.contactID) {
                                        this.currTerminMitBenutzer.termin.contactID = dialogData.objektAdresseZuord.contactID;
                                    }
                                }, error: (err) => console.error('Fehler: ', err),
                            });
                        }
                    }
                },
            });
        } else {
            this.svcMessageBox.showWarning('Objekt muss zuvor ausgewählt werden', '!! Warnung !!');
        }
    }

    endTimeChanged($event: any): void {
        const startDate: Date = new Date(this.formGroupTermin.get('fldStartDatum')?.value);
        const endDate: Date = new Date(this.formGroupTermin.get('fldEndDatum')?.value);

        const startTime = this.formGroupTermin.get('fldStartZeit')?.value.split(':');
        const endTime = $event.target.value.split(':');

        startDate.setHours(startTime[0], startTime[1]);
        endDate.setHours(endTime[0], endTime[1]);

        if (moment(endDate).isBefore(moment(startDate))) {
            this.formGroupTermin.get('fldStartZeit')?.setValue($event.target.value);
        }
    }

    startTimeChanged($event: any): void {
        const startDate: Date = new Date(this.formGroupTermin.get('fldStartDatum')?.value);
        const endDate: Date = new Date(this.formGroupTermin.get('fldEndDatum')?.value);

        const startTime = $event.target.value.split(':');
        const endTime = this.formGroupTermin.get('fldEndZeit')?.value.split(':');

        startDate.setHours(startTime[0], startTime[1]);
        endDate.setHours(endTime[0], endTime[1]);

        if (moment(startDate).isAfter(moment(endDate))) {
            this.formGroupTermin.get('fldEndZeit')?.setValue($event.target.value);
        }
    }

    protected startDateChanged($event: MatDatepickerInputEvent<any, any>): void {
        const startDate = $event.value as Moment;
        const endDate = this.formGroupTermin.get('fldEndDatum')?.value;
        if (endDate == null || endDate && startDate.isAfter(endDate)) {
            this.formGroupTermin.get('fldEndDatum')!.setValue(startDate.toDate());
        }
        if (endDate == null || endDate && (startDate.isSame(endDate, 'date') || startDate.isAfter(endDate))) {
            this.startTimeChanged({target: {value: this.formGroupTermin.get('fldStartZeit')?.value}});
        }
    }

    protected endDateChanged($event: MatDatepickerInputEvent<any, any>): void {
        const endDate = $event.value as Moment;
        const startDate = this.formGroupTermin.get('fldStartDatum')?.value;
        if (startDate == null || endDate && endDate.isBefore(startDate)) {
            this.formGroupTermin.get('fldStartDatum')!.setValue(endDate.toDate());
            this.endTimeChanged({target: {value: this.formGroupTermin.get('fldEndZeit')?.value}});
        }

        if (startDate == null || endDate && (startDate.isSame(endDate, 'date') || endDate.isBefore(startDate))) {
            this.startTimeChanged({target: {value: this.formGroupTermin.get('fldStartZeit')?.value}});
        }
    }

    private loadFieldValues(): void {
        if (this.currTerminMitBenutzer.termin.startDate) {
            this.formGroupTermin.get('fldStartDatum')!.setValue(this.currTerminMitBenutzer.termin.startDate);
        }
        if (this.currTerminMitBenutzer.termin.startTime) {
            this.formGroupTermin.get('fldStartZeit')!.setValue(this.currTerminMitBenutzer.termin.startTime);
        }
        if (this.currTerminMitBenutzer.termin.endDate) {
            this.formGroupTermin.get('fldEndDatum')!.setValue(this.currTerminMitBenutzer.termin.endDate);
        }
        if (this.currTerminMitBenutzer.termin.endTime) {
            this.formGroupTermin.get('fldEndZeit')!.setValue(this.currTerminMitBenutzer.termin.endTime);
        }

        if (this.currTerminMitBenutzer.istNeuerTermin) {
            // Neuer Termin wird erstellt
            this.nurMeinenTerminAktualisieren = false;
            if (this.currTerminMitBenutzer.termin.username) {
                const mitarbeiter = this.dbMitarbeiter?.find((x) => x.loginname.toLowerCase() == this.currTerminMitBenutzer.termin.username.toLowerCase());
                if (mitarbeiter) {
                    this.formGroupTermin.get('fldMitarbeiter')!.setValue([mitarbeiter.userID]);
                }
                this.formGroupTermin.get('fldStatus')!.setValue(this.currTerminMitBenutzer.termin.busyStatus);
                this.formGroupTermin.get('fldErinnerung')!.setValue(this.currTerminMitBenutzer.termin.reminderNumber);

                if (this.currTerminMitBenutzer.termin.objectID !== '') {
                    const obj = this.objekte.find((o) => o.objectID === this.currTerminMitBenutzer.termin.objectID);
                    this.formGroupTermin.get('fldObjekt')!.setValue(obj);
                    this.loadObjectAdressen();
                }
            }
        } else {
            // Bestehender Termin wird bearbeitet
            this.nurMeinenTerminAktualisieren = true;
            this.formGroupTermin.get('fldStatus')!.setValue(this.currTerminMitBenutzer.termin.busyStatus);
            this.formGroupTermin.get('fldErinnerung')!.setValue(this.currTerminMitBenutzer.termin.reminderNumber);
            if (this.currTerminMitBenutzer.terminKategorien) {
                const categories = this.currTerminMitBenutzer.terminKategorien.map((tk) => tk.categoryID);
                this.formGroupTermin.get('fldKategorie')!.setValue(categories);
            }
            if (this.currTerminMitBenutzer.termin.private === 1) {
                this.formGroupTermin.get('fldPrivat')!.setValue(1);
            }
            const obj = this.objekte.find((o) => o.objectID === this.currTerminMitBenutzer.termin.objectID);
            this.formGroupTermin.get('fldObjekt')!.setValue(obj);
            this.loadObjectAdressen(this.currTerminMitBenutzer.termin.adressID);

            if (this.currTerminMitBenutzer.termin.description) {
                this.formGroupTermin.get('fldTitel')!.setValue(this.currTerminMitBenutzer.termin.description);
            }

            if (this.currTerminMitBenutzer.termin.location) {
                this.formGroupTermin.get('fldOrt')!.setValue(this.currTerminMitBenutzer.termin.location);
            }

            if (this.currTerminMitBenutzer.mitarbeiter) {
                let mitits: number[] = [];
                this.currTerminMitBenutzer.mitarbeiter.forEach((mi) => {
                    mitits.push(mi.userID);
                });
                this.formGroupTermin.get('fldMitarbeiter')!.setValue(mitits);
            }

            if (this.currTerminMitBenutzer.termin.notes) {
                this.formGroupTermin.get('fldNotizen')!.setValue(this.currTerminMitBenutzer.termin.notes);
            }

            // Standardmässig soll nur der Termin des aktuellen Benutzers aktualisiert werden,
            // auch wenn andere Mitarbeiter auch noch den gleichen Termin haben (wird über GroupID gesteuert)
            this.formGroupTermin.get('fldNurMeinenTermin')!.setValue(1);
        }

    }

    private _filter(value: string): MainDataModels.SearchFieldResponseObjekt[] {
        if (value && typeof value === 'string') {
            const filterValue = value.toLowerCase();

            if (this.objekte && this.objekte.length > 0) {
                // Sternsuche
                if (filterValue.length > 1 && filterValue[0] === '*') {
                    const searchValue = filterValue.substring(1, filterValue.length);
                    return this.objekte.filter((objekt) => objekt.beschreibung && objekt.beschreibung.toLowerCase().indexOf(searchValue) >= 0);
                } else {
                    return this.objekte.filter((objekt) => objekt.beschreibung && objekt.beschreibung.toLowerCase().indexOf(filterValue) === 0);
                }
            } else {
                return this.objekte;
            }
        } else {
            return [];
        }
    }

    private loadObjectAdressen(adresseID: string = ''): void {
        this.svcMainData.getTerminObjektAdressen(this.currTerminMitBenutzer.termin.objectID).subscribe({
            next: (res) => {
                if (res) {
                    this.objectAddresses = res;
                    // Eintrag für andere Adressen hinzufügen
                    if (adresseID) {
                        const objAdr = this.objectAddresses.find((oa) => oa.adressID === this.currTerminMitBenutzer.termin.adressID);
                        if (objAdr) {
                            this.formGroupTermin.get('fldAdresse')!.setValue(objAdr);
                        }
                    } else {
                        // Wenn nur eine Adresse existiert, dann diese vorselektieren
                        if (this.objectAddresses.length === 1) {
                            this.formGroupTermin.get('fldAdresse')!.setValue(this.objectAddresses[0]);
                        } else if (this.objectAddresses.length > 1) {
                            // Wenn es mehr als eine Kundenadresse hat --> gibt es eine Kundenadresse?
                            // Wenn ja, vorselektieren!
                            const objAdr = this.objectAddresses.find((oa) => oa.typ === 1);
                            if (objAdr) {
                                this.formGroupTermin.get('fldAdresse')!.setValue(objAdr);
                            }
                        }
                    }
                }
            },
        });
    }
}
